import * as React from 'react';
import get from 'lodash/get';
import { EditState } from 'app/infrastructure/ui/form/types';
import { getLocationOfInitiator } from 'app/area/case/draft/connected-state';

import styles from './connected-cases.scss';
import { FullscreenModalHeader } from 'ui';
import { LocationDescriptorObject } from 'history';
import { ConnectedCase } from 'app/area/bowtie/types-store';

interface ConnectedCasesProps {
  previousUrl?: LocationDescriptorObject;
  connected?: ConnectedCase[];
  editing: EditState;
  translation: { [key: string]: string };
  children?: React.ReactNode;
}

/**
 * When a draft is in the state of beeing connected to another case/draft, then this banner renders
 * the backdrop view
 *
 * @param param0
 */
export const ConnectedCaseInfoModal: React.FC<ConnectedCasesProps> = ({
  editing,
  children,
  translation,
  connected = get(editing, 'connectedDrafts.length') && editing.connectedDrafts.slice(-1)[0],
  previousUrl = getLocationOfInitiator(editing.connectedDrafts)
}) => <div
  className={get(connected, 'draftId') ? `connected-case-display ${styles.connectCaseDisplay}` : ''}
>
    {
      get(connected, 'draftId') ?
      <div>
        <div className={styles.connectedCaseHeader}>
          <FullscreenModalHeader previousUrl={previousUrl}>
            {translation.you_are_connecting_a_new_case}
          </FullscreenModalHeader>
        </div>
        <div className={`modal-background ${styles.connectedCaseBg}`} />
      </div> : ''
    }
    {children}
  </div>;
